/**
 * Space Query Errors
 *
 * Helpers for recognizing expected cancellation paths in Space queries.
 *
 * Primary responsibilities:
 * - Detect TanStack Query cancellation errors
 * - Normalize browser abort-style cancellation checks
 */

export const isSpaceQueryCancelledError = (error: unknown) => {
  if (error instanceof DOMException) {
    return error.name === "AbortError"
  }

  if (!(error instanceof Error)) {
    return false
  }

  return (
    error.constructor.name === "CancelledError" ||
    error.name === "AbortError" ||
    error.name === "CanceledError" ||
    error.name === "CancelledError" ||
    error.message === "CancelledError"
  )
}
